import React from 'react'
import styles from './styles.module.scss'
import { useTranslations } from 'next-intl'
import { useCurrentProduct } from '@/src/context/product/current-product-context'

export default function ObservationCard() {
    const { setObservation, observation } = useCurrentProduct()
    const t = useTranslations('modal-product')

    return (
        <textarea
            defaultValue={observation}
            onChange={({ target }) => setObservation(target.value)}
            className={styles.observation}
            placeholder={t('observations')}
            cols={3}
            rows={3}
            maxLength={250}
        >
        </textarea>
    )
}
